import React from "react";
import { methode } from "../data/mockData";

export const Methode = () => (
  <section id="methode" className="section">
    <div className="shell">
      <div className="mx-auto max-w-[840px] text-center">
        <h2 className="h2">
          Comment se déroule <em>un mandat</em>
        </h2>
        <p className="lede mt-6">
          Quatre étapes, du premier appel jusqu'à l'autonomie de vos équipes.
        </p>
      </div>

      <ol className="mt-10 lg:mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {methode.map((etape, i) => (
          <li key={etape.titre} className="card">
            <span className="text-vt-legende font-extrabold uppercase tracking-[0.12em] text-t3">
              Étape {i + 1}
            </span>
            <h3 className="mt-3 text-vt-h3 font-bold text-brand">{etape.titre}</h3>
            <p className="mt-2 leading-relaxed text-t2">{etape.texte}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
